import TextField from "@mui/material/TextField";
import AddItemDialog from "../../Dialogs/AddItemDialog";
import MenuItem from "@mui/material/MenuItem";
import { useEffect, useState } from "react";
import { Grade } from "../../../types/App";
import { ExamOverviewRow } from "../../../interfaces/examInterfaces";
import { createErrorText } from "../Functions";

const AddExamDialog = ({
  open,
  handleCancel,
  saveExam,
  grades,
  paths,
  pathString,
}: {
  open: boolean;
  handleCancel: () => void;
  saveExam: (name: string, grade: Grade) => void;
  grades: number[] | null;
  paths: Record<string, ExamOverviewRow[]> | null;
  pathString: string;
}) => {
  const [grade, setGrade] = useState<Grade | null>(null);
  const [name, setName] = useState("");
  const [touchedName, setTouchedName] = useState(false);
  const [touchedGrade, setTouchedGrade] = useState(false);
  const [dialogInitialized, setDialogInitialized] = useState(false);
  const [errorText, setErrorText] = useState<string | null>(null);

  const resetFields = () => {
    setGrade(null);
    setName("");
    setTouchedName(false);
    setTouchedGrade(false);
    setDialogInitialized(false);
  };

  useEffect(() => {
    if (open) {
      setDialogInitialized(true);
    } else {
      resetFields();
    }
  }, [open]);

  useEffect(() => {
      setErrorText(createErrorText(paths, pathString, name))
  }, [name])
  

  return (
    <AddItemDialog
      open={open}
      handleCancel={() => handleCancel()}
      handleConfirm={() => {
        if (grade !== null) {
          setTouchedName(false);
          saveExam(name, grade);
        }
      }}
      title={"Neue Prüfung"}
      description={"Bitte wähle die Stufe und benenne die Prüfung"}
      confirmText={"OK"}
      confirmAllowed={grade !== null && errorText === null}
    >
      <TextField
        sx={{ mt: "16px" }}
        fullWidth
        variant="outlined"
        margin="dense"
        color="primary"
        id="grade"
        label="Stufe"
        error={touchedGrade && grade == null}
        select
        value={grade ?? ""}
        onBlur={() => setTouchedGrade(true)}
        onChange={(e) => {
          const value = e.target.value === "" ? null : Number(e.target.value);
          setGrade(value as Grade);
        }}
        onKeyDown={(e) => {
          if (e.code === "Enter" && grade !== null && errorText === null) {
            saveExam(name, grade);
          }
        }}
      >
        {grades?.map((val) => (
          <MenuItem key={val} value={val}>
            {val}
          </MenuItem>
        ))}
        {grades?.length === 0 && (
          <MenuItem disabled={true}>
            <i>Du hast keine gültige Lizenz.</i>
          </MenuItem>
        )}
      </TextField>
      <TextField
        variant="outlined"
        margin="dense"
        color="primary"
        id="name"
        label="Name"
        required
        error={errorText !== null && touchedName}
        fullWidth
        autoFocus
        onBlur={() => {
          if (dialogInitialized) {
            setTouchedName(true);
          }
        }}
        onChange={(e) => {
          setName(e.target.value);
          setTouchedName(true);
        }}
        onKeyDown={(e) => {
          if (e.code === "Enter" && grade !== null && errorText === null) {
            saveExam(name, grade);
          }
        }}
        helperText={errorText ?? errorText}
      />
    </AddItemDialog>
  );
};

export default AddExamDialog;
